/**
 * The one merchant a set of rows belongs to, or undefined when they span several.
 *
 * SKU reads on the server are per merchant: a merchant login needs no merchantId, a
 * Prozo-admin login (cross-merchant scope) is refused without one. Callers pass this
 * result along so the common case — one merchant — just works, and the admin-on-the-
 * merchant-panel case degrades to the module's honest fallbacks instead of a 400.
 *
 * Kept free of imports so components and their tests can use it without pulling in
 * the API layer (which reaches the axios/redux setup).
 */
export function singleMerchantOf(rows) {
  const ids = new Set((rows || []).map((r) => r && r.merchantId).filter(Boolean))
  return ids.size === 1 ? Array.from(ids)[0] : undefined
}
